<p>allow-notification-sheet works!</p>
